<script lang="ts">
    import {Component, Watch, Vue, toNative} from 'vue-facing-decorator'
    import CityAutocomplete from '@/components/search/forms/CityAutocomplete.vue'

    @Component({mixins: [CityAutocomplete]})
    export class CountryAutocomplete extends Vue {
        @Watch('value')
        onChangeValue(val) {
            this.city = val
            if (val && Object.keys(val).length && !this.entries.find(({id}) => id === val.id)) {
                this.entries = [val]
            } else if (!val || !Object.keys(val).length) {
                this.entries = this.defaultCities
            }
        }

        async searchCountries(val, checkTryResearch = true) {
            const rq = {
                pattern: val.trim() + '%',
                limitCountries: 10,
                orderBy: 'POPULARITY',
                ...(this.productType && {productType: this.productType}),
            }
            const rs = await this.$api.locations.get(rq, this.cancelTokenSource.token)

            if (rs && rs.countries.length === 0 && checkTryResearch) {
                this.tryResearch.status = true
                this.tryResearch.message = this.isMobile
                    ? this.$t('try_rewrite_destination_mobile')
                    : this.$t('try_rewrite_destination')
            }
            return rs?.countries || []
        }

        async initSearch(val) {
            if ((this.entries.length > 0 && this.entries.indexOf(val) !== -1) || !val) return
            this.loading = true
            this.cancelTokenSource?.cancel('Operation canceled by the user.')
            this.cancelTokenSource = this.$axios.CancelToken.source()

            try {
                this.entries = await this.searchCountries(val)
            } catch (e) {
                /* empty */
            } finally {
                this.loading = false
            }
        }

        get isMobile() {
            return this.$breakpoint.smAndDown
        }

        itemLabel(entry) {
            return entry.name
        }
    }

    export default {...toNative(CountryAutocomplete), ssrRender: CityAutocomplete.ssrRender}
</script>

<style scoped lang="scss">
    :deep(.v-dialog) {
        overflow-y: hidden;
    }
    :deep(.v-label) {
        font-size: inherit;
    }

    :deep(.v-autocomplete__selection) {
        line-height: unset !important;
        height: unset !important;
        display: flex;
        align-items: start;
    }
</style>
